/* Spanish catalog mirroring locale-customers-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'sup.archiveBody': '¿Quieres archivar a {name}? El proveedor se oculta de las listas de proveedores activos, pero se conservan las facturas, los pagos y el historial. Podrás reabrir el proveedor más adelante.',
  'cust.title': 'Clientes',
  'cust.subtitle': 'Todos tus clientes en un solo lugar',
  'cust.searchPh': 'Buscar cliente o importe',
  'cust.titleHelp': 'Tu registro de clientes: todos los clientes con datos de contacto, importes pendientes y ventas totales. Pulsa un cliente para ver el seguimiento y las facturas.',
  'cust.searchHelp': 'Busca clientes por nombre, correo electrónico, ventas totales o importe pendiente.',
  'cust.uploadHelp': 'Importar clientes desde un archivo.',
  'cust.downloadHelp': 'Descargar la lista de clientes en CSV o Excel.',
  'cust.addHelp': 'Añadir un cliente nuevo con datos de contacto y estado de seguimiento.',
  'cust.filterHelp': 'Filtra los clientes por estado (activo, prospecto, presupuesto enviado, en pausa), según tengan importes pendientes o no, y elige si se muestran los clientes archivados.',
  'cust.listHelpTitle': 'La lista de clientes',
  'cust.listHelp': 'Cada fila es un cliente con número de cliente, número de empresa, correo electrónico, teléfono, importe pendiente y ventas totales. Pulsa una fila para abrir el cliente.',
  'cust.filterOther': 'Otros',
  'cust.filterWithOutstanding': 'Solo con importes pendientes',
  'cust.filterShowArchive': 'Mostrar archivados',
  'cust.archived': 'Archivado',
  'cust.followUpInline': 'Seguimiento {date}',
  'cust.col.customer': 'Cliente',
  'cust.col.number': 'N.º de cliente',
  'cust.col.org': 'N.º de empresa',
  'cust.col.email': 'Correo electrónico',
  'cust.col.phone': 'Teléfono',
  'cust.col.outstanding': 'Pendiente',
  'cust.col.totalSales': 'Ventas totales',
  'cust.outstandingInline': 'Pendiente {amount}',
  'cust.balance.customerOwes': 'El cliente te debe {amount}',
  'cust.balance.youOwe': 'Le debes {amount} al cliente',
  'cust.balance.settled': 'Saldado',
  'cust.followUp': 'Seguimiento',
  'cust.followUpHelp': 'Estado, próxima fecha de seguimiento, notas y actividad reciente del cliente. Usa el botón de chat para registrar una conversación y preparar un presupuesto.',
  'cust.dialogTitle': 'Conversación con el cliente',
  'cust.dialogHelp': 'Abre una conversación con el cliente: registra mensajes y prepara una base de presupuesto que puedes convertir en presupuesto.',
  'cust.openChat': 'Abrir chat',
  'cust.startChat': 'Iniciar chat',
  'cust.nextFollowUp': 'Próximo seguimiento',
  'cust.noFollowUpDate': 'Sin fecha definida',
  'cust.status': 'Estado',
  'cust.salesTitle': 'Ventas del cliente',
  'cust.salesHelp': 'Todas las facturas y notas de crédito del cliente. Filtra por todas, pendientes de pago o pagadas, y abre una factura directamente con «Abrir».',
  'cust.salesAll': 'Todas',
  'cust.salesUnpaid': 'Pendientes de pago',
  'cust.salesPaid': 'Pagadas',
  'cust.salesTotal': 'Total',
  'cust.noSalesMatch': 'Ninguna venta coincide con el filtro.',
  'cust.creditNote': 'Nota de crédito',
  'cust.invoice': 'Factura',
  'cust.dueOn': 'Vence el {date}',
  'cust.open': 'Abrir',
  'cust.pageRange': '{from}-{to} de {total}',
  'cust.prev': 'Anterior',
  'cust.next': 'Siguiente',
  'cust.act.newInvoice': 'Nueva factura',
  'cust.act.newInvoiceHelp': 'Empezar una factura nueva con este cliente ya seleccionado.',
  'cust.act.edit': 'Editar',
  'cust.act.editHelp': 'Cambiar los datos de contacto, el estado y el seguimiento del cliente.',
  'cust.act.merge': 'Fusionar',
  'cust.act.mergeHelp': 'Fusionar dos clientes registrados por duplicado: las ventas y los importes pendientes se combinan en un solo cliente.',
  'cust.act.archive': 'Archivar',
  'cust.act.archiveHelp': 'Ocultar el cliente de las listas activas. Se conservan las facturas, los pagos y el historial.',
  'cust.act.menu': 'Acción',
  'cust.archiveTitle': '¿Archivar?',
  'cust.archiveBody': '¿Quieres archivar a {name}? El cliente se oculta de las listas de clientes activos, pero se conservan las facturas, los pagos y el historial.',
  'cust.archiveStillUsed': 'El cliente todavía se usa en otros lugares',
  'cust.archiveGroup': '{n} grupo de clientes',
  'cust.archiveGroups': '{n} grupos de clientes',
  'cust.archiveSubscription': '{n} suscripción',
  'cust.archiveSubscriptions': '{n} suscripciones',
  'cust.archiveAnd': ' y ',
  'cust.merge.title': 'Fusionar clientes',
  'cust.merge.keep': 'Se conserva',
  'cust.merge.remove': 'Fusionado y eliminado',
  'cust.merge.swap': 'Intercambiar el cliente que se conserva',
  'cust.merge.after': 'Después de fusionar',
  'cust.merge.name': 'Nombre del cliente',
  'cust.merge.totalSales': 'Ventas totales',
  'cust.merge.notConnected': 'La fusión aún no está conectada al backend.',
  'cust.merge.done': 'Los clientes se han fusionado',
  'cust.merge.failed': 'No se pudieron fusionar los clientes.',
  'cust.form.name': 'Nombre del cliente',
  'cust.form.namePh': 'P. ej. Ejemplo S.L.',
  'cust.form.orgOptional': 'N.º de empresa (opcional)',
  'cust.form.org': 'N.º de empresa',
  'cust.form.address': 'Dirección',
  'cust.form.addressPh': 'Dirección postal',
  'cust.form.zip': 'Código postal',
  'cust.form.city': 'Localidad',
  'cust.form.cityPh': 'Localidad',
  'cust.form.crm': 'Estado del cliente',
  'cust.form.nextLabel': 'Próximo: {date}',
  'cust.form.noFollowUp': 'Sin seguimiento',
  'cust.form.dupTitle': 'Otro cliente ya tiene este dato',
  'cust.form.dupName': '{names} tiene el mismo nombre.',
  'cust.form.dupOrg': '{names} tiene el mismo número de empresa.',
  'cust.form.dupEmail': '{names} tiene la misma dirección de correo electrónico.',
  'cust.form.dupPhone': '{names} tiene el mismo número de teléfono.',
  'cust.form.dupUnnamed': 'Un cliente sin nombre',
  'cust.form.dupBody': 'El cliente se guarda con normalidad. Si es el mismo cliente, puedes fusionar ambos desde la ficha del cliente en la lista.',
  'cust.form.contacts': 'Personas de contacto',
  'cust.form.contactsSub': 'Se pueden elegir como destinatarios al enviar una factura, un presupuesto o un recibo.',
  'cust.form.addContact': 'Añadir persona de contacto',
  'cust.form.editContact': 'Editar persona de contacto',
  'cust.form.contactFallback': 'Persona de contacto {n}',
  'cust.form.removeContact': 'Quitar persona de contacto',
  'cust.form.contactTitle': 'Persona de contacto',
  'cust.form.newTitle': 'Nuevo cliente',
  'cust.form.editTitle': 'Editar cliente',
  'cust.form.saveContact': 'Guardar',
  'cust.form.contactName': 'Nombre',
  'cust.form.contactNamePh': 'P. ej. Ana López',
  'cust.form.contactRole': 'Cargo',
  'cust.form.contactRolePh': 'P. ej. Contabilidad',
  'cust.form.defaultRef': 'Referencia fija de factura',
  'cust.form.defaultRefPh': 'P. ej. número de proyecto, pedido de compra o departamento',
  'cust.form.creditLimit': 'Límite de crédito',
  'cust.form.creditLimitHint': 'Se usa en la conciliación para comparar el saldo abierto del cliente con tu política de crédito. Un límite nunca bloquea la facturación.',
  'cust.form.creditLimitPh': 'P. ej. 60000',
  'cust.form.note': 'Nota del cliente',
  'cust.form.notePh': 'Nota sobre el cliente',
  'cust.form.activity': 'Añadir una nota de actividad',
  'cust.form.activityPh': 'Llamé al cliente, envié una actualización de precios…',
  'cust.form.update': 'Actualizar cliente',
  'cust.form.save': 'Guardar cliente',
  'cust.crm.prospect': 'Prospecto',
  'cust.crm.quoteSent': 'Presupuesto enviado',
  'cust.crm.active': 'Cliente activo',
  'cust.crm.pause': 'En pausa',
  'cust.chat.scope.all': 'Toda la conversación',
  'cust.chat.scope.to': 'Al cliente',
  'cust.chat.scope.from': 'Del cliente',
  'cust.chat.scope.internal': 'Notas internas',
  'cust.chat.helpAll': 'Estás viendo toda la conversación.',
  'cust.chat.helpTo': 'Estás viendo los mensajes que has enviado.',
  'cust.chat.helpFrom': 'Estás viendo los mensajes del cliente.',
  'cust.chat.helpInternal': 'Estas son tus notas internas de la conversación.',
  'cust.chat.threadsHelpTitle': 'Conversaciones',
  'cust.chat.threadsHelp': 'Cada cliente puede tener varias conversaciones. Cambia entre ellas aquí o inicia una nueva para una consulta nueva.',
  'cust.chat.conversation': 'Conversación',
  'cust.chat.filterTitle': 'Filtrar la conversación',
  'cust.chat.filterHelp': 'Elige qué quieres ver en la ventana de abajo: toda la conversación, los mensajes enviados, los mensajes del cliente o las notas internas.',
  'cust.chat.windowTitle': 'Ventana de conversación',
  'cust.chat.windowHelp': 'Los mensajes de la conversación. Lo que envías aparece a la derecha; los mensajes del cliente y las notas internas, a la izquierda. Arrastra el borde inferior para agrandar la ventana.',
  'cust.chat.internal': 'Interno',
  'cust.chat.newInternalTitle': 'Nueva nota interna',
  'cust.chat.saveInDialog': 'Guardar en la conversación',
  'cust.chat.saveMessage': 'Guardar mensaje',
  'cust.chat.sendMessage': 'Enviar mensaje',
  'cust.chat.newTitle': 'Nuevo mensaje',
  'cust.chat.newHelp': 'Escribe una respuesta al cliente, pega un mensaje recibido o anota algo internamente. El filtro de conversación seleccionado decide si se envía al cliente, se guarda como mensaje del cliente o se guarda como nota interna.',
  'cust.chat.draftPh': 'Escribe una respuesta, pega un mensaje del cliente o anota lo que habéis acordado...',
  'cust.chat.newDialog': 'Nueva conversación',
  'cust.chat.quoteTitle': 'Base del presupuesto',
  'cust.chat.quoteHelp': 'Añade los productos y precios acordados en la conversación. Pulsa Crear presupuesto para convertirlo en un borrador de presupuesto con el cliente ya rellenado.',
  'cust.chat.findProduct': 'Buscar producto/precio',
  'cust.chat.productPh': 'Buscar producto...',
  'cust.chat.dragToMessage': 'Arrastrar al mensaje',
  'cust.chat.dragTotal': 'Arrastrar el total al mensaje',
  'cust.chat.dragBasis': 'Arrastrar toda la base del presupuesto al mensaje',
  'cust.chat.quoteBasis': 'Toda la base',
  'cust.chat.remove': 'Quitar',
  'cust.chat.total': 'Total',
  'cust.chat.makeQuote': 'Crear presupuesto',
  'cust.toast.updated': 'Cliente actualizado',
  'cust.toast.saved': 'Cliente guardado',
  'cust.toast.saveFailed': 'No se pudo guardar el cliente.',
  'cust.toast.archived': 'Cliente archivado',
  'cust.toast.archiveFailed': 'No se pudo archivar el cliente.',
  'cust.toast.nothingToExport': 'No hay clientes que exportar',
  'cust.toast.exportFailed': 'No se pudo exportar la lista de clientes.',
  'cust.toast.exported': 'Lista de clientes descargada',
  'cust.toast.noLedgerRows': 'No hay líneas del libro de clientes que exportar',
  'cust.toast.ledgerExportFailed': 'No se pudo exportar el libro de clientes.',
  'cust.toast.ledgerExported': 'Libro de clientes descargado',
  'cust.toast.wrongFormat': 'Usa un archivo CSV o XLSX con la plantilla de clientes de Plumme.',
  'cust.toast.noneInFile': 'No se encontraron clientes en el archivo.',
  'cust.toast.imported': '{n} clientes importados',
  'cust.toast.importFailed': 'No se pudieron importar los clientes.',
  'cust.error.xlsxImport': 'La importación XLSX aún no está disponible.',
  'cust.error.xlsxExport': 'La exportación a Excel aún no está disponible.',
  'cust.export.number': 'Customer number',
  'cust.export.name': 'Name',
  'cust.export.org': 'Organization number',
  'cust.export.email': 'Email',
  'cust.export.phone': 'Phone',
  'cust.export.address': 'Address',
  'cust.export.zip': 'Postal code',
  'cust.export.city': 'Postal place',
  'cust.export.status': 'Status',
  'cust.export.followUp': 'Follow up',
  'cust.export.defaultRef': 'Default invoice reference',
  'cust.export.note': 'Note',
  'cust.ledger.code': 'Código',
  'cust.ledger.date': 'Fecha',
  'cust.ledger.doc': 'N.º de justificante/factura',
  'cust.ledger.type': 'Tipo',
  'cust.ledger.due': 'Vencimiento',
  'cust.ledger.debit': 'Debe',
  'cust.ledger.credit': 'Haber',
  'cust.ledger.balance': 'Saldo tras la línea',
  'cust.ledger.paid': 'Pagado',
  'cust.ledger.remaining': 'Restante',
  'cust.ledger.partial': 'Pagada parcialmente',
  'cust.ledger.unpaid': 'Pendiente de pago',
  'cust.ledger.posted': 'Contabilizado',
  'cust.ledger.refund': 'Reembolso al cliente',
  'cust.ledger.payment': 'Pago del cliente',
  'cust.ledger.creditOverpayment': 'Crédito / pago en exceso',
  'cust.ledger.empty': 'Aún no hay líneas en el libro de clientes.',
  'cust.import': 'Importar',
  'cust.importFrom': 'Importar desde',
  'cust.ledgerShort': 'Libro de clientes',
  'cust.ledger.sheet': 'Libro de clientes',
  'cust.sheet.customers': 'Clientes',
});
